
document.addEventListener('DOMContentLoaded', function() {
    function addHoverClass(elementSelector, className) {
        var elements = document.querySelectorAll(elementSelector);
        elements.forEach(function(element) {
            element.addEventListener('mouseenter', function() {
                element.classList.add(className);
            });
            element.addEventListener('mouseleave', function() {
                element.classList.remove(className);
            });
        });
    }

    function addHoverClassThree(elementSelector, className) {
        var elements = document.querySelectorAll(elementSelector);
        elements.forEach(function(element) {
            element.addEventListener('mouseenter', function() {
                var target = element.previousElementSibling;
                if (target ) {
                    target.classList.add(className);
                }
            });
            element.addEventListener('mouseleave', function() {
                var target = element.previousElementSibling;
                if (target) {
                    target.classList.remove(className);
                }
            });
        });
    }

    // Usage Example:
    addHoverClass('.level_two > li >  a', 'hovered');
    addHoverClassThree('.level_three', 'hovered');


  var elements = document.querySelectorAll(".level_two > li >  a span");
        elements.forEach(function(element) {
            element.addEventListener('click', function() {
                element.parentNode.classList.add("hoveredd");
            });
        });

document.querySelectorAll('span.link-icon').forEach(function(element) {
  element.addEventListener('click', function() {
    this.parentElement.classList.toggle('selected');
  });
});

document.querySelectorAll('nav >ul > li >a').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
        if(document.querySelectorAll('nav button[aria-expanded="true"]').length){
                window.location.href = this.getAttribute('href');
        }
    });
});  
   
});










document.addEventListener("DOMContentLoaded", function () {


  
   setTimeout(function(){ 



  var flic = 0; var timerflic = setInterval(function(){
  if(document.querySelector(".upsell-products") != null && typeof $.fn.owlCarousel !== 'undefined' && document.querySelector('.upsell-products.owl-carousel.owl-loaded.owl-drag') == null) {


    document.querySelectorAll('[x-data="CartItemQuantity"] div > button:first-child').forEach(button => {
  button.addEventListener('click', function() {
    var t = this;
     setTimeout(function(){ 


    const input = t.nextElementSibling;
    if (input && input.value <= 1) {
      const parent = t.closest('[x-data="CartItemQuantity"]');
      if (parent) {
        const link = parent.querySelector('p a');
        if (link) {
          link.click();
        }
      }
    }
       }, 250);
  });
});


 var elem = $(".cartDrawer .upsell-products");
 var elem2 = $(".recommended-section .upsell-products");

var $slider = $(".upsell-product-slider .upsell-products")
    $slider.trigger("destroy.owl.carousel");
    $slider.html($slider.find(".owl-stage-outer").html()); // Remove Owl markup
    
var numItems = $('.upsell-product').attr('num-items');
  

$(document).ready(function () {
  elem.owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    responsive: {
            0: {   // Mobile (up to 767px)
                items: 1
            },
            1000: { // Tablet and above
                items: 2
            }
        }
  });
  elem2.owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    dotsEach: 1,
    responsive: {
            0: {   // Mobile (up to 767px)
                items: 2
            },
            768: { // Tablet and above
                items: 2
            },
            1200: { // Tablet and above
                items: numItems
            }
        }
  });
});



  document.querySelectorAll(".upsell-atc").forEach(function (button) {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-id"); // Get variant ID

      if (variantId) {
        addToCart(variantId);
      }
    });
  });

  function addToCart(variantId) {
    console.log('heress');
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
        "Source": "Upsell", // Add your custom property here
      },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Added to cart:", data);

        // Dispatch the cart update event
       if($('[x-show="$store.modals.rightDrawer.open"][style*="none"]').length){
         document.querySelectorAll('button#CartButton')[0].click()
       }
        document.dispatchEvent(new CustomEvent("theme:update:cart"));
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

    ;}flic++;}, 50);
     }, 500);
});